import { tabsListAStock } from './config';
import { getZhongQianData } from '../../../common/client-agreement/booking';
import { moduleType } from './constant';
import Vue from 'vue';

const win: any = window;

const pageSource: string | false = win.F10Utils.getUrlParams('source');

const { hxmClickStat } = win;

export const isJiaoYi = pageSource === 'jiaoyi';

if(isJiaoYi){
  const originStatFn = hxmClickStat;
  win.hxmClickStat = function(id:string,ext:any){
    const jiaoyiStatId = id.replace('free_ipo','free_ipojy');
    originStatFn(jiaoyiStatId,ext);
  }
}

/**
 * 获取根视图额外所需的类名，用于覆盖原有样式属性.
 * 1. 如果页面处于交易页面，添加 hideLevel1Tab 类名。隐藏一级Tab
 */
export const getRootViewClass = () => {
  if (isJiaoYi) {
    return 'hideLevel1Tab';
  }

  return '';
};

/**
 * 获取A股页面的二级TabList
 * 1. 位于交易页面时，去除“可申购”tab项
 */
export const getTabListAStock = () => {
  if (isJiaoYi) {
    return tabsListAStock.filter(item => item.name !== 'todayBuy');
  }

  return tabsListAStock;
};

/**
 * 获取A股页面的二级TabList的默认选中项
 * 1. 位于交易页面时，默认第0个 willBuy
 *
 */
export const getDefaultSelectedTabAStock = () => {
  if (isJiaoYi) {
    return 'willBuy';
  }

  return 'todayBuy';
};

/**
 * 获取A股页面 src\ipo\src\pages\indexPage\pages\aStock\index.vue 中默认的tab对象索引
 * 1. 位于交易页面时，选中第0个
 */
export const getDefaultTabIndexAStock = () => {
  if (isJiaoYi) {
    return 0;
  }

  return 1;
};

/**
 * A股页面底部按钮配置
 * @returns
 */
export const getBtnConfig = () => {
  if (isJiaoYi) {
    return { btnStyle: null, btnText: '' };
  }

  return {};
};

interface ZqData {
  stock_code: string;
}

/**
 * 渲染中签数据
 */
export const renderZhongqianData = (list: any[], vm: Vue) => {
  if (!isJiaoYi) {
    return;
  }

  // 异步获取中签数据
  getZhongQianData((zqList: ZqData[]) => {
    const map: Record<string, ZqData> = {};
    zqList.forEach(item => {
      map[item.stock_code] = item;
    });

    list.forEach(item => {
      if (item.code in map || item.orderCode in map) {
        vm.$set(item, 'isZq', true);
        item.isZq = true;
      }
    });
  });
};

/**
 * 页面首次加载默认请求类型
 */
export const defaultModule = () => {
  if (!isJiaoYi) {
    return { module: moduleType.ORDER };
  }
  return { module: moduleType.WAITORDER };
};
